import { render, staticRenderFns } from "./QuestionRestartButton.vue?vue&type=template&id=b9adce3e&scoped=true&"
import script from "./QuestionRestartButton.vue?vue&type=script&lang=js&"
export * from "./QuestionRestartButton.vue?vue&type=script&lang=js&"
import style0 from "./question-restart-button.scss?vue&type=style&index=0&id=b9adce3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9adce3e",
  null
  
)

export default component.exports